import type { ImageBleed } from 'types';

export type SideBleed = Extract<ImageBleed, 'left' | 'right'>;

// An outer column of a 3-column row that bleeds to the screen edge. ModuleRow
// frames these columns edge to edge, and ProductList drops its own padding and
// width cap inside them, so both must agree on which columns qualify.
export function isSideBleedColumn(
  bleed: ImageBleed | undefined,
  numColumns: number | undefined
): bleed is SideBleed {
  return numColumns === 3 && (bleed === 'left' || bleed === 'right');
}
